const styles = theme => ({
  page: {
    width: "100%",
    height: "100%",
    [theme.breakpoints.up("lg")]: {
      display: "flex",
      flexDirection: "row",
      "&> div:nth-of-type(1)": {
        flex: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      },
      "&> div:nth-of-type(2)": {
        flex: 1
      }
    }
  },
  white: {
    color: theme.palette.secondary.light,
    [theme.breakpoints.down("md")]: {
      color: theme.palette.primary.main
    }
  },
  formContainer: {
    minHeight: "initial",
    [theme.breakpoints.up("lg")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: theme.palette.primary.main
    }
  },
  loginTitle: {
    color: theme.palette.primary.main,
    [theme.breakpoints.up("lg")]: {
      color: "#fff",
      textAlign: "center"
    }
  },
  form: {
    display: "flex",
    flexDirection: "column"
  },
  formControl: {
    margin: `${theme.spacing(2)}px 0`
  },

  mobileInput: {
    "&:before": {
      borderBottomColor: theme.palette.secondary.light
    },
    WebkitTextFillColor: theme.palette.secondary.light,
    [theme.breakpoints.down("md")]: {
      "&:before": {
        borderBottomColor: theme.palette.primary.main
      },
      WebkitTextFillColor: theme.palette.primary.main
    }
  },
  passwordInput: {
    "&:before": {
      borderBottomColor: theme.palette.secondary.light
    },
    WebkitTextFillColor: theme.palette.secondary.light,
    [theme.breakpoints.down("md")]: {
      "&:before": {
        borderBottomColor: theme.palette.primary.main
      },
      WebkitTextFillColor: theme.palette.primary.main
    }
  },
  loginButton: {
    left: -9000,
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      left: "initial",
      display: "block",
      marginTop: 25,
      fontSize: 20,
      color: theme.palette.primary.main,
      fontWeight: "700",
      borderRadius: 2
    }
  },
  forgotPassword: {
    "&> a": {
      textDecoration: "none",

      "&> p": {
        [theme.breakpoints.up("md")]: {
          color: theme.palette.secondary.light
        },
        [theme.breakpoints.down("md")]: {
          color: theme.palette.primary.main
        }
      }
    }
  },
  // forgotPasswordPhone: {
  //   [theme.breakpoints.down("md")]: {
  //     color: theme.palette.primary.main + "!important"
  //   }
  // },
  formRegister: {
    display: "none",
    // position: "absolute",
    // bottom: 200,
    margin: theme.spacing(1),
    color: theme.palette.secondary.light,
    textAlign: "center",
    "&> a": {
      textDecoration: "none",
      color: theme.palette.secondary.light,
      fontWeight: 700
    },
    [theme.breakpoints.up("lg")]: {
      display: "block"
    }
  },
  bottomNav: {
    [theme.breakpoints.up("lg")]: {
      display: "none"
    }
  },
  version: {
    position: "absolute",
    right: 0,
    bottom: 60,
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      bottom: 20,
      color: "#fff"
    }
  },
  spinnerColor: {
    color: "white"
  },
  buttonProgress: {
    color: "white",
    marginTop: "2px"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Login/styles.js